__turbopack_context__.v({
  "author": "_7XlpBa_author",
  "description": "_7XlpBa_description",
  "headline": "_7XlpBa_headline",
  "image": "_7XlpBa_image",
  "imageNext": "_7XlpBa_imageNext",
  "imageNext2": "_7XlpBa_imageNext2",
  "imagePrevious": "_7XlpBa_imagePrevious",
  "imageSelected": "_7XlpBa_imageSelected",
  "imagesWrapper": "_7XlpBa_imagesWrapper",
  "next": "_7XlpBa_next",
  "next2": "_7XlpBa_next2",
  "nextButton": "_7XlpBa_nextButton",
  "previous": "_7XlpBa_previous",
  "root": "_7XlpBa_root",
  "selected": "_7XlpBa_selected",
  "stars": "_7XlpBa_stars",
  "testimonial": "_7XlpBa_testimonial",
  "testimonialSelected": "_7XlpBa_testimonialSelected",
  "testimonialsWrapper": "_7XlpBa_testimonialsWrapper",
});
